<template>
  <v-dialog
    v-no-scroll
    v-bind="$attrs"
    v-on="$listeners"
    :content-class="$attrs['content-class'] + (loading ? ' hidden' : '')"
  >
    <v-dialog
      v-if="loading"
      fullscreen
      :transition="null"
      :value="true"
      @input="v => $emit('input', v)"
    >
      <div class="fill-height d-flex justify-center align-center" @click="$emit('input', false)">
        <v-progress-circular color="white" indeterminate />
      </div>
    </v-dialog>
    <slot></slot>
  </v-dialog>
</template>

<style>
.hidden {
  display: none;
}
</style>

<script>
export default {
  name: 'v-dialog-loader',
  props: [ 'loading' ]
}
</script>
